/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt />
    </div>
    <!-- ------------------------------------- -->
    <el-menu-item v-for="(item,i) in navList" :key="i" :index="item.name">
      <i class="iconfont icon-cat-skuQuery"></i>
      <span slot="title">{{ item.navItem }}</span>
    </el-menu-item>

    <!-- <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
      <i class="iconfont" :class="chmenu.icon"></i>
      <span>{{chmenu.menuname}}</span>
    </el-menu-item>-->
    <!-- -------------------------------------- -->
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
  export default {
    name: "leftnav",
    data() {
      return {
        collapsed: false,
        allmenu: [],
        navList: [
          {
            name: "/monitoring/Monitoring",
            navItem: "车辆监控"
          }
        ]
      };
    },

    // computed: {
    //   isFollow() {
    //     return this.$store.state.show; //需要监听的数据
    //   }
    // },
    // watch: {
    //   isFollow(newVal, oldVal) {
    //     this.isShow = !this.isShow;
    //   }
    // },
    // 创建完毕状态(里面是操作)
    created() {
      // 获取图形验证码
      let res = {
        success: true,
        data: [
          // {
          //   menuid: 1,
          //   icon: "li-icon-xiangmuguanli",
          //   menuname: "车辆监控",
          //   hasThird: null,
          //   url: null,
          //   menus: [
          //     {
          //       menuid: 2,
          //       icon: "icon-cat-skuQuery",
          //       menuname: "车辆监控",
          //       hasThird: "N",
          //       url: "monitoring/Monitoring",
          //       menus: null
          //     }
          //   ]
          // },
         

          {
            menuid: 10,
            icon: "li-icon-xiangmuguanli",
            menuname: "区域管理",
            hasThird: null,
            url: null,
            menus: [
              {
                menuid: 11,
                icon: "icon-cat-skuQuery",
                menuname: "区域管理",
                hasThird: "N",
                url: "area_mn/Area_mn",
                menus: null
              }
            ]
          },
          {
            menuid: 33,
            icon: "li-icon-dingdanguanli",
            menuname: "车辆管理",
            hasThird: null,
            url: null,
            menus: [
              {
                menuid: 34,
                icon: "icon-order-manage",
                menuname: "车辆管理",
                hasThird: "N",
                url: "vehicle_mn/Vehicle_mn",
                menus: null
              }
            ]
          },
          {
            menuid: 71,
            icon: "li-icon-xitongguanli",
            menuname: "运维管理",
            hasThird: null,
            url: null,
            menus: [
              // {
              //   menuid: 72,
              //   icon: "icon-cus-manage",
              //   menuname: "巡检工单",
              //   hasThird: "N",
              //   url: "operation_mn/Operation_mn",
              //   menus: null
              // },
              {
                menuid: 174,
                icon: "icon-cms-manage",
                menuname: "故障通知",
                hasThird: "N",
                url: "operation_mn/Fault_order",
                menus: null
              },
              // {
              //   menuid: 73,
              //   icon: "icon-news-manage",
              //   menuname: "综合工单",
              //   hasThird: "N",
              //   url: "operation_mn/Zh_order",
              //   menus: null
              // }
            ]
          },
          {
            menuid: 128,
            icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
            menuname: "地图管理",
            hasThird: null,
            url: null,
            menus: [
              {
                menuid: 129,
                icon: "icon-provider-manage",
                menuname: "地图管理",
                hasThird: "N",
                url: "map_mn / Map_mn",
                menus: null
              }
              
            ]
          }
          
        ],
        msg: "success"
      };
      this.allmenu = res.data;

      // menu(localStorage.getItem('logintoken'))
      //   .then(res => {
      //     console.log(JSON.stringify(res))
      //     if (res.success) {
      //       this.allmenu = res.data
      //     } else {
      //       this.$message.error(res.msg)
      //       return false
      //     }
      //   })
      //   .catch(err => {
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
      // 监听
      this.$root.Bus.$on("toggle", value => {
        this.collapsed = !value;
      });
    }
  };
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
  }

  .logoimg {
    height: 40px;
  }
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue